import { Box, BoxProps } from "@chakra-ui/react";

function CategoryManagementIcon({
  color = "currentColor",
  ...props
}: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 17 18"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.41667 8.16797L8 0.667969L12.5833 8.16797H3.41667ZM12.5833 17.3346C11.5417 17.3346 10.6562 16.9701 9.92708 16.2409C9.19792 15.5117 8.83333 14.6263 8.83333 13.5846C8.83333 12.543 9.19792 11.6576 9.92708 10.9284C10.6562 10.1992 11.5417 9.83463 12.5833 9.83463C13.625 9.83463 14.5104 10.1992 15.2396 10.9284C15.9687 11.6576 16.3333 12.543 16.3333 13.5846C16.3333 14.6263 15.9687 15.5117 15.2396 16.2409C14.5104 16.9701 13.625 17.3346 12.5833 17.3346ZM0.5 16.918V10.2513H7.16667V16.918H0.5ZM12.5833 15.668C13.1667 15.668 13.6597 15.4666 14.0625 15.0638C14.4653 14.661 14.6667 14.168 14.6667 13.5846C14.6667 13.0013 14.4653 12.5082 14.0625 12.1055C13.6597 11.7027 13.1667 11.5013 12.5833 11.5013C12 11.5013 11.5069 11.7027 11.1042 12.1055C10.7014 12.5082 10.5 13.0013 10.5 13.5846C10.5 14.168 10.7014 14.661 11.1042 15.0638C11.5069 15.4666 12 15.668 12.5833 15.668ZM2.16667 15.2513H5.5V11.918H2.16667V15.2513ZM6.375 6.5013H9.625L8 3.8763L6.375 6.5013Z"
          fill="currentColor"
        />
      </svg>
    </Box>
  );
}

export { CategoryManagementIcon };
